<template>
    <div class="story__body" data-flex="row">

        <StoryImage
            :src="memberSrc(person.media)"
            priority="high"
        />

        <article data-v-animate class="has-overflow">

            <StoryHead 
                :title="title(person)"
                :subtitle="person.job"
            />

            <p v-html="person.text" />

            <link-button
                :href="person.linked"
                :text="`Connect <span class='screen'>with me</span>`"
                @click.native="click(person.linked)"
            />

        </article>

    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { teamImage } from '@/mixins/images'

import StoryHead from '../Story/StoryHead'
import StoryImage from '../Story/StoryImage'

export default {
    name: 'TeamMember',
    metaInfo() {
        const { name } = this.person
        return {
            title: `Connect with ${name}`,
        }
    },
    props: ['slug', 'photo'],
    mixins: [ teamImage ],
    components: { 
        StoryHead,
        StoryImage,
    },
    methods: {
        click( url ) {
            let handler = window.open(url, '_blank')
            handler.focus()
        },
        title( person ) {
            return person.name.split(' ')
        },
    },
    computed: {
        person() {
            const x = this.members.findIndex(
                member => member.slug === this.slug
            )
            return this.members[x]
        },
        ...mapGetters(['members'])
    }
}
</script>
